import ComplaintListWithCreate from './ComplaintListWithCreate'

export default ComplaintListWithCreate
